import React from "react";
import Lottie from "react-lottie";
import * as animationData from "./loading.json";
import "./loading.css";
import { Grid, Typography } from "@mui/material";

const loading = (props) => {
  const { status, isStopped, isPaused } = props;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Grid
      className="main_popup_loading"
      style={{ display: status ? "block" : "none" }}
    >
      <img
        src="/images/ico_alert.svg"
        style={{ display: "none" }}
        alt=""
        className="ico_alert"
      />
      <Grid className="background_opacity_loading"></Grid>
      <Grid>
        <Grid className="loading-content">
          <Lottie
            options={defaultOptions}
            height={70}
            width={70}
            isStopped={isStopped}
            isPaused={isPaused}
          />
          <Grid className="loading-content-text">
            <Typography>กรุณารอสักครู่</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default loading;
